import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customBaseURL, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_BINS_LIST, GET_BINS_LIST_SUCCESS, GET_BINS_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBinsList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/card-list`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        // ...customHeaders,
        'project-code': localStorage.getItem('bankCode') ?? 'MASTERCARD_KSA',
      },
      params: {
        ...payload?.urlParam,
        pageSize: 100,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BINS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BINS_LIST_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BINS_LIST_ERROR, payload: error });
  }
}

export function* watchGetBinsList() {
  yield takeEvery(GET_BINS_LIST, getBinsList);
}

function* getBinsListSaga() {
  yield all([fork(watchGetBinsList)]);
}

export default getBinsListSaga;
